import { Client } from "@smash-sdk/core";
import { errors } from "./errors";
import jwtDecode from 'jwt-decode';
import { FailedToDecodeTokenError } from "./types/DecodeToken/DecodeTokenError";
export class ExtendedIam extends Client {
    constructor(params) {
        super(params);
        this.errors = errors;
    }
    decodeToken(token) {
        return new Promise((resolve, reject) => {
            try {
                const { id, username, region, ip, scope, account, iat: issuedAt, exp: expiration, } = jwtDecode(token);
                resolve({
                    id,
                    username,
                    region,
                    ip,
                    scope,
                    account,
                    issuedAt: new Date(issuedAt * 1000).toISOString(),
                    expiration: new Date(expiration * 1000).toISOString(),
                });
            }
            catch (error) {
                reject(new FailedToDecodeTokenError(error));
            }
        });
    }
}
